import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../buildStore';
import { getWaveformLevel } from '../selectors/voiceInputSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const Canvas = styled.canvas.withConfig({
  displayName: "VoiceInputWaveform__Canvas"
})(["display:block;flex:1;min-width:0;height:28px;"]);
const BAR_WIDTH = 2;
const BAR_GAP = 2;
const BAR_COLOR = '#ff4800';
const MIN_BAR_HEIGHT_FRACTION = 0.1;
export const MAX_HISTORY = 500;
const AMPLITUDE_GAIN = 1.4;
export function scaleLevel(level) {
  return Math.min(1, Math.sqrt(level) * AMPLITUDE_GAIN);
}
const VoiceInputWaveform = () => {
  const canvasRef = useRef(null);
  const historyRef = useRef([]);
  const rafRef = useRef(0);
  const waveformLevel = useAppSelector(getWaveformLevel);
  useEffect(() => {
    const history = historyRef.current;
    history.push(scaleLevel(waveformLevel));
    if (history.length > MAX_HISTORY) history.splice(0, history.length - MAX_HISTORY);
  }, [waveformLevel]);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const draw = () => {
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const dpr = window.devicePixelRatio || 1;
      const cssWidth = canvas.offsetWidth;
      const cssHeight = canvas.offsetHeight;
      if (canvas.width !== Math.round(cssWidth * dpr) || canvas.height !== Math.round(cssHeight * dpr)) {
        canvas.width = Math.round(cssWidth * dpr);
        canvas.height = Math.round(cssHeight * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, cssWidth, cssHeight);
      ctx.lineCap = 'round';
      ctx.lineWidth = BAR_WIDTH;
      ctx.strokeStyle = BAR_COLOR;
      const barCount = Math.floor(cssWidth / (BAR_WIDTH + BAR_GAP));
      const history = historyRef.current;
      const offset = history.length - barCount;
      for (let i = 0; i < barCount; i++) {
        const historyIndex = offset + i;
        const level = historyIndex >= 0 ? history[historyIndex] : 0;
        const barHeight = Math.max(cssHeight * MIN_BAR_HEIGHT_FRACTION, level * cssHeight);
        const x = i * (BAR_WIDTH + BAR_GAP) + BAR_WIDTH / 2;
        const y = (cssHeight - barHeight) / 2;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x, y + barHeight);
        ctx.stroke();
      }
      rafRef.current = requestAnimationFrame(draw);
    };
    rafRef.current = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);
  return /*#__PURE__*/_jsx(Canvas, {
    ref: canvasRef,
    "aria-hidden": "true"
  });
};
VoiceInputWaveform.displayName = 'VoiceInputWaveform';
export default VoiceInputWaveform;